export default [
  {
    label: "Why Rollins",
    startsWith: "#",
    columns: [
      [
        {
          label: "Why Rollins Professional Advancement",
          url: "/professional-advancement/why-rollins",
          description:
            "Find out why Rollins’ Professional Advancement programs are the perfect place to finish your degree and unlock your professional potential.",
          image: null,
        },
        {
          label: "Designed to Fit Your Life",
          url: "/professional-advancement/why-rollins/bachelor-degree-programs-for-working-adults",
          description:
            "Rollins’ Professional Advancement programs are designed specifically for adult learners with busy lives. Explore our flexible format.",
          image: null,
        },
        {
          label: "Personalized Learning Environment",
          url: "/professional-advancement/why-rollins/personalized-learning-environment",
          description:
            "Our educational model centers around you—giving you the expert support you need to thrive in our classrooms and in your career.",
          image: null,
        },
      ],
      [
        {
          label: "Aid & Affordability",
          url: "/professional-advancement/why-rollins/affordable-bachelor-degree-programs",
          description:
            "Finishing your degree is one of your life’s best investments. Learn more about Rollins’ commitment to financial aid.",
          image: null,
        },
        {
          label: "Seamless Transfer",
          url: "/professional-advancement/why-rollins/seamless-transfer",
          description:
            "From our guaranteed admission policy to a course plan built just for you, find out how we smooth the path to your degree.",
          image: null,
        },
        {
          label: "Orlando’s Top-Ranked College",
          url: "/professional-advancement/why-rollins/best-college-in-orlando",
          description:
            "Find out how you can leverage our top-ranked reputation to advance your career and unlock your earning potential.",
          image: null,
        },
      ],
      [
        {
          label: "Chart Your Own Course",
          url: "/professional-advancement/why-rollins/chart-your-own-course",
          description:
            "Craft a one-of-a-kind educational journey that is tuned to where you’ve been and where you’re going.",
          image: null,
        },
        {
          label: "Rollins Results",
          url: "/professional-advancement/why-rollins/orlando-careers",
          description:
            "See your bright future come into focus by exploring the lives and careers of the Rollins grads who have gone before you.",
          image: null,
        },
      ],
    ],
  },
  {
    label: "Degree Programs",
    startsWith: "#",
    url: "/professional-advancement/degree-programs",
  },
  {
    label: "Apply",
    startsWith: "#",
    url: "/professional-advancement/apply",
  },
  {
    label: "Visit",
    startsWith: "#",
    url: "/professional-advancement/visit",
  },
  {
    label: "Tuition & Aid",
    startsWith: "#",
    url: "/professional-advancement/tuition-aid",
  },
  {
    label: "News",
    startsWith: "#",
    url: "/professional-advancement/news",
  },
];
